import axios from "axios";

export const GET_ALL_TICKET = "GET_ALL_TICKET";
export const GET_ONE_TICKET = "GET_ONE_TICKET";
export const ADD_TICKET = "ADD_TICKET";
export const MODIF_TICKET = "MODIF_TICKET";
export const GET_ONE_TICKET_GRAPHQL = "GET_ONE_TICKET_GRAPHQL";
export const DELETE_TICKET = "DELETE_TICKET";
export const GET_ALL_TICKET_GRAPHQL = "GET_ALL_TICKET_GRAPHQL";
export const GET_ALL_TICKET_NO_FILTER = "GET_ALL_TICKET_NO_FILTER";

const POPULATE_TICKETS = `populate[ticket_priority]=true&populate[ticket_object]=true&populate[ticket_statut]=true&populate[ticket_type]=true&populate[ticket_motif]=true&populate[ticket_origin]=true&
populate[materials]=true&populate[contract]=true&populate[company]=true&populate[sites]=true&
populate[buildings]=true&populate[rooms]=true&populate[contacts]=true&populate[escalation_level_group]=true&
populate[lastUpdatedBy]=true&populate[responsible_user]=true&populate[creator_user]=true&
populate[documents][populate]=*&populate[ticket_histories]=true`;

export const getAllTickets =
  (affectDefaultList = true) =>
  (dispatch) => {
    try {
      return axios
        .get(`/tickets?_limit=5000&${POPULATE_TICKETS}`)
        .then((cli) => {
          //si on veut changer le state par defaut utilisé (tickets)
          if (affectDefaultList) {
            dispatch({ type: GET_ALL_TICKET, payload: cli.data.data });
          }
          dispatch({ type: GET_ALL_TICKET_NO_FILTER, payload: cli.data.data });
        });
    } catch (error) {
      console.log("ERREUR GET ALL TICKET ", error);
    }
  };

export const getOneTicket = (id) => (dispatch) => {
  const urlWithDocumentId = `/tickets/${id}?${POPULATE_TICKETS}`;
  const urlWithId = `/tickets?filters[number][$eq]=${id}&${POPULATE_TICKETS}`;
  const url = id?.length > 10 ? urlWithDocumentId : urlWithId;
  try {
    return axios.get(url);
  } catch (error) {
    console.log("ERREUR ", error);
  }
};

export const addTicket = (ticketState, history) => (dispatch) => {
  try {
    const jwt = localStorage.getItem("clientmmgmt");
    return new Promise((resolve, reject) => {
      axios
        .get("/users/me", { headers: { Authorization: `Bearer ${jwt}` } })
        .then((res) => {
          const user = res.data;

          resolve(
            axios
              .post("/tickets", {
                data: { ...ticketState, creator_user: user.id },
              })
              .then((cli) => {
                dispatch({ type: ADD_TICKET, payload: cli.data });
              })
              .catch((err) => reject({ error: err }))
          );
        })
        .catch((err) => reject({ error: err }));
    });
  } catch (error) {
    console.log("ERREUR AJOUT TICKET!", error);
  }
};

export const updateTicket = (ticketState) => (dispatch) => {
  try {
    const documentId = ticketState.documentId;
    delete ticketState.documentId;
    return axios.put(`/tickets/${documentId}`, { data: ticketState });
    // .then(cli => {
    //     dispatch({ type: MODIF_TICKET, payload: cli.data })
    // });
  } catch (error) {
    console.log("ERREUR MODIFICATION TICKET ", error);
  }
};

export const getOneTicketGraphql = (id) => (dispatch) => {
  try {
    const querya = `query TicketDetails($tid: ID!) {
                ticket(id: $tid) {
                    id
                    created_at
                    ticket_statut {
                        id
                        name
                        slug
                    }
                    ticket_priority {
                        id
                        name
                        classofprio
                    }
                    ticket_object {
                        id
                        name
                    }
                    ticket_motif {
                        id
                        name
                    }
                    ticket_type {
                        id
                        name
                    }
                    ticket_origin {
                        id
                        name
                    }
                    contract {
                        id
                        created_at
                        montant
                        slas {
                            id
                            gti
                            gtr
                        }
                    }
                    comment
                    escalation_level_group {
                        id
                    }
                    responsible_user {
                        id
                        username
                        email
                        name
                        lastname
                        escalation_level_group {
                            id
                        }
                    }
                    lastUpdatedBy {
                        id
                        username
                        email
                        name
                        lastname
                    }
                    objet
                    company {
                        id
                        name
                        contact_owner {
                            id
                            firstName
                            lastName
                        }
                    }
                    contacts {
                        id
                        firstName
                        lastName
                        email
                        fix_number
                        mobile_number
                    }
                    closedDate
                    updated_at

                  }
                }
            }`;
    const variablesa = { tid: id };

    const body = {
      query: querya,
      variables: variablesa,
    };

    return axios.post("/graphql", body);
  } catch (error) {
    console.log("ERREUR GET_ONE_TICKET_GRAPHQL", error);
  }
};

export const deleteTicket = (id) => (dispatch) => {
  try {
    return axios.delete(`/tickets/${id}`).then((cli) => {
      dispatch({ type: DELETE_TICKET, payload: cli.data });
    });
  } catch (error) {
    console.log("ERREUR DELETE TICKET ", error);
  }
};

export const getAllTicketsGraphql = () => (dispatch) => {
  try {
    const querya = `query getTickets {
                tickets {
                    id
                    number
                    created_at
                    updated_at
                    ticket_statut {
                        id
                        name
                        slug
                        color
                    }
                    ticket_priority {
                        id
                        name
                        color
                        classofprio
                    }
                    ticket_object {
                        id
                        name
                    }
                    ticket_motif {
                        id
                        name
                    }
                    ticket_type {
                        id
                        name
                    }
                    ticket_origin {
                        id
                        name
                    }
                    contract {
                        id
                        created_at
                        montant
                        slas {
                            id
                            gti
                            gtr
                        }
                    }
                    comment
                    escalation_level_group {
                        id
                    }
                    responsible_user {
                        id
                        username
                        email
                        name
                        lastname
                        escalation_level_group {
                            id
                        }
                    }
                    lastUpdatedBy {
                        id
                        username
                        email
                        name
                        lastname
                    }
                    objet
                    company {
                        id
                        name
                        contact_owner {
                            id
                            firstName
                            lastName
                        }
                    }
                    contacts {
                        id
                        firstName
                        lastName
                        email
                        fix_number
                        mobile_number
                    }
                    closedDate
                }
            }`;

    const body = {
      query: querya,
    };

    return axios.post("/graphql", body).then((cli) => {
      dispatch({ type: GET_ALL_TICKET, payload: cli.data.data.tickets });
    });
  } catch (error) {
    console.log("ERREUR GET_ALL_TICKET_GRAPHQL", error);
  }
};

export const getFilteredTicketsGraphql =
  (filters, company = null) =>
  (dispatch) => {
    try {
      let wql = `filters: {`;

      filters.length > 0 &&
        filters.forEach((f, index) => {
          if (f.field !== "id") {
            if (f.field.includes(".")) {
              const table = f.field.split(".")[0];
              const tableField = f.field.split(".")[1];
              wql += `${table} : {${tableField} : {${f.comparator}:"${f.value}" }}`;
            } else {
              if (f.field === "comments") {
                wql += `ticket_histories : {field : {eq : "comments"}, newValue : {${f.comparator}:"${f.value}"}}`;
              } else {
                wql += `${f.field}:{${f.comparator}:"${f.value}"}`;
              }
            }
            if (index < filters.length - 1) {
              wql += ",";
            }
          }
        });
      
      if (company) {
        wql += `, company: {documentId : {eq: "${company.documentId}"}}`;
      }

      wql += "}";

      //console.log("wql", wql);

      const querya = `query getTickets {
                tickets(${wql},pagination: { limit: 1000}) {
                    documentId
                    number
                    createdAt
                    updatedAt
                    ticket_statut {
                        documentId
                        name
                        slug
                        color
                        class
                    }
                    ticket_priority {
                        documentId
                        name
                        color
                        classofprio
                    }
                    ticket_object {
                        documentId
                        name
                    }
                    ticket_motif {
                        documentId
                        name
                    }
                    ticket_type {
                        documentId
                        name
                    }
                    ticket_origin {
                        documentId
                        name
                    }
                    contract {
                        documentId
                        createdAt
                        montant
                        slas {
                            documentId
                            gti
                            gtr
                        }
                    }
                    comment
                    escalation_level_group {
                        documentId
                    }
                    responsible_user {
                        documentId
                        username
                        email
                        name
                        lastname
                        escalation_level_group {
                            documentId
                        }
                    }
                    lastUpdatedBy {
                        documentId
                        username
                        email
                        name
                        lastname
                    }
                    objet
                    company {
                        documentId
                        name
                        contact_owner {
                            documentId
                            firstName
                            lastName
                        }
                    }
                    contacts {
                        documentId
                        firstName
                        lastName
                        email
                        fix_number
                        mobile_number
                    }
                    closedDate
                    ticket_histories{
                        documentId
                        field
                        newValue
                    }
                }
            }`;

      const body = {
        query: querya,
      };

      //console.log('body', body)

      return axios.post("/graphql", body).then((cli) => {
        const tickets = cli.data.data.tickets;
        getTicketsWithId(tickets).then((ticketWithIds) => {
          let filteredTickets = ticketWithIds;

          dispatch({ type: GET_ALL_TICKET, payload: filteredTickets });

          /*
          const filterId = filters.filter((f) => f.field === "id");

          if (filterId.length > 0) {
            const currentFilterId = filterId[0];
            filteredTickets = filteredTickets?.filter((t) => {
              if (currentFilterId.comparator === "contains") {
                return t?.id.toString().includes(currentFilterId.value);
              } else if (currentFilterId.comparator === "notContains") {
                return !t?.id.toString().includes(currentFilterId.value);
              } else if (currentFilterId.comparator === "eq") {
                return t?.id.toString() === currentFilterId.value;
              } else if (currentFilterId.comparator === "ne") {
                return t?.id.toString() !== currentFilterId.value;
              }
            });
          }

          if (company) {
            filteredTickets = filteredTickets?.filter(
              (t) => t?.company?.documentId === company.documentId
            );
            dispatch({ type: GET_ALL_TICKET, payload: filteredTickets });
          } else {
            dispatch({ type: GET_ALL_TICKET, payload: filteredTickets });
          }
            */
        });
      });
    } catch (error) {
      console.log("ERREUR GET_ALL_TICKET_GRAPHQL", error);
    }
  };

export const getCompanyTickets = (company) => (dispatch) => {
  //console.log('ticketAction.getCompanyTickets.param', companyID);
  if (!company)
    return console.error("Erreur getCompanyTickets! companyID est vide!");
  try {
    //console.log(`/tickets?_limit=5000&company.id=${companyID}`)
    //return axios.get("/tickets?_limit=5000")
    const companyId = company.id;
    return axios
      .get(
        `/tickets?pagination[start]=0&pagination[limit]=1000&filters[company][$eq]=${companyId}&${POPULATE_TICKETS}`
      )
      .then((cli) => {
        const tickets = cli.data.data;
        //console.log(tickets)
        // const filteredTickets = tickets?.filter((t) => t?.company?.id === companyID);
        // console.log(filteredTickets)
        //dispatch({ type: GET_ALL_TICKET, payload: filteredTickets });
        dispatch({ type: GET_ALL_TICKET, payload: tickets });
      });
  } catch (error) {
    console.log("ERREUR GET ALL TICKET ", error);
  }
};

export const getAllTicketsBySearchKey =
  (searchKey, companyID) => (dispatch) => {
    // Build GraphQL filters dynamically
    let filtersString = `filters: {
      or: [
        { number: { containsi: "${searchKey}" } }
        { objet: { containsi: "${searchKey}" } }
        { comment: { containsi: "${searchKey}" } }
      ]`;

    // Add company filter if companyID is provided
    if (companyID) {
      filtersString += `
      company: { documentId: { eq: "${companyID.documentId || companyID}" } }`;
    }

    filtersString += `
    }`;

    const querya = `query getTickets {
        tickets(${filtersString}, pagination: { limit: 100}) {
            documentId
            number
            objet
            comment
            company {documentId}
        }
    }`;

    const body = {
      query: querya,
    };

    return new Promise((resolve, reject) => {
      axios
        .post("/graphql", body)
        .then((cli) => {
          const tickets = cli.data.data.tickets;
          resolve(tickets);
        })
        .catch((err) => reject({ error: err }));
    });
  };

export const getAllTicketsSync = () => {
  try {
    return axios.get(`/tickets?_limit=5000&${POPULATE_TICKETS}`);
  } catch (error) {
    console.log("ERREUR GET ALL TICKET ", error);
  }
};

export const selectTicket = (ticket) => (dispatch) => {
  dispatch({ type: GET_ONE_TICKET, payload: ticket });
};

export const getAllTicketsNotFiltered = () => (dispatch) => {
  //console.log("all...")
  dispatch(getAllTickets(false));
};

const getTicketsWithId = async (tickets) => {
  let filter = tickets.map((t, index) => {
    return `&filters[documentId][$in][${index}]=${t.documentId}`;
  });

  const filters = filter.join("");

  const temp = await axios.get(
    `/tickets?fields=documentId${filters}`
  );

  const mergedArray = tickets.map((item) => {
    const matchingItem = temp.data.data.find(
      (secondItem) => secondItem.documentId === item.documentId
    );
    return {
      ...item,
      id: matchingItem ? matchingItem.id : null, // Assign `null` if no match
    };
  });

  return mergedArray;
};
